// tabMenuInit 関数がインスタンスを返す
export default function tabMenuInit(coreHandler) {
  const targetClassName = "js__tabmenu-btn";

  class TabMenu {
    static instanceList = [];
    static state = coreHandler.searchParam.getValue("mode") || "material";
    static tabMenu = document.getElementsByClassName("js__tabmenu");
    static gradeSearch = document.getElementById("js__main") || null;

    constructor(domItem) {
      this.ele = domItem;
      this.instanceType = "TabMenu";
      this.mode = this.ele.getAttribute("data-mode");
      this.type = this.ele.getAttribute("data-type");
      this.propertyId = this.ele.getAttribute("data-open-property");
      this.clickHandler = this.switchEvent.bind(this);

      if (coreHandler === undefined) {
        throw new Error("Can't get coreHandler instance");
      }
    }

    static init = (targetClassName) => {
      let domList = document.getElementsByClassName(targetClassName);
      if (domList.length < 1) throw new Error("dom elements is not found");
      TabMenu.instanceList = [...domList].map(domItem => new TabMenu(domItem));
    }

    static setGradeSearchAttribute = (mode) => {
      if( !TabMenu.gradeSearch ) return false;
      TabMenu.gradeSearch.setAttribute('data-mode', mode);
    }

    static loadEvent = () => {
      let recentMode = coreHandler.searchParam.getValue("mode") || "material";
      TabMenu.switchTab(recentMode , false);
      TabMenu.btnStateUpdate();
    }

    static setEventListener = () => {
      TabMenu.instanceList.map(instance => instance.ele.addEventListener("click", instance.clickHandler, true));
    }
    static removeEventListener = () => {
      TabMenu.instanceList.map(instance => instance.ele.removeEventListener("click", instance.clickHandler, true));
    }

    static allReset = () => {
      TabMenu.removeEventListener();
      TabMenu.instanceList = [];
    }

    static rebuild = () => {
      TabMenu.allReset();
      TabMenu.init(targetClassName);
      TabMenu.setEventListener();
    }

    static btnStateUpdate = () => {
      TabMenu.instanceList.forEach(instance => instance.changeActive());
    }

    static setState = (instance) => {
      TabMenu.state = instance.mode;
    }
    static getState = () => {
      return TabMenu.state;
    }

    static switchTab = (modeString, resetFlag = true) => {

      [...TabMenu.tabMenu].forEach(menu => {
        const mode = menu.getAttribute("data-mode");
        if (modeString === mode) {
          menu.classList.add("is-active");
          menu.style.display = "block";
        } else {
          menu.classList.remove("is-active");
          menu.style.display = "none";
        };
        TabMenu.setGradeSearchAttribute( modeString );
      });

      if(resetFlag === true ){
        coreHandler.allReset();
      }

    }

    switchEvent = () => {
      if (this.mode === TabMenu.getState()) return false;
      TabMenu.switchTab(this.mode);
      if(this.propertyId){
        coreHandler.accordionClass.openFromProp( this.propertyId );
      }
      coreHandler.searchParam.add(this);

      TabMenu.setState(this);
      TabMenu.btnStateUpdate();
    }


    changeActive = () => {
      let mode = TabMenu.getState();
      if (this.type !== "menu") return false;
      if (this.mode === mode) {
        this.ele.classList.add("is-active");
      } else {
        this.ele.classList.remove("is-active");
      }
    }

    tabReset() {
      console.log( coreHandler );
      // if (coreHandler !== null) {
      //   coreHandler.allReset();
      // }
    }

  }


  TabMenu.init(targetClassName);
  TabMenu.setEventListener();

  return TabMenu;
}